import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('app.UsersPage.OffboardUserPopupContent.PopupButtonsStep2', {
    error: 'Please select a user',
    offBoardButtonText: 'Offboard',
    backButtonText: 'Back',
});
